import { atom } from "@mongez/react-atom";
import { Offer } from "../types";

export const offerAtom = atom<Offer>({
  key: "offer",
  default: {},
});
